export default function toFloat(value: any): number | null {



    if (typeof value === "number") {

        // If the value is already a number, return it as a floating-point number
        return value

    } else if (typeof value === "string") {

        // If the value is a string, try to parse it as a floating-point number
        const floatNum = parseFloat(value)
        if (!isNaN(floatNum)) {
            // If the parsing was successful, return the floating-point number
            return floatNum;
        }
    }

    // If the value cannot be converted to a floating-point number, return NaN
    return null
}